// @flow strict
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import ConstellationV2 from '../components/ConstellationV2';
import { useSiteMetadata } from '../hooks';


// Not shown on the page any more — this is the meta description only.
const DESCRIPTION = 'A constellation of my passions — writing on product, AI, poetry and life.';

const toPost = (edge) => ({
  slug: edge.node.fields.slug,
  timeToRead: edge.node.timeToRead,
  ...edge.node.frontmatter
});

const ConstellationV2Template = ({ data }) => {
  const { title: siteTitle } = useSiteMetadata();

  // Two newest articles, then the newest reflection. The filters mirror the
  // ones the /  and /reflections feeds use, so "newest" here means the same
  // post that sits at the top of those pages.
  const featured = [
    ...data.articles.edges,
    ...data.reflections.edges
  ].map(toPost);

  return (
    <Layout title={siteTitle} description={DESCRIPTION} fullWidth>
      <ConstellationV2 featured={featured} />
    </Layout>
  );
};

export const query = graphql`
  query ConstellationV2Template {
    articles: allMarkdownRemark(
      limit: 2,
      filter: { frontmatter: { template: { eq: "post" }, draft: { ne: true }, poetry: { ne: true }, reflections: { ne: true }, photograph: { ne: true } } },
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          timeToRead
          fields { slug }
          frontmatter { title date category description }
        }
      }
    }

    reflections: allMarkdownRemark(
      limit: 1,
      filter: { frontmatter: { template: { eq: "post" }, draft: { ne: true }, poetry: { ne: true }, reflections: { ne: false } } },
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          timeToRead
          fields { slug }
          frontmatter { title date category description }
        }
      }
    }
  }
`;

export default ConstellationV2Template;
